import { IPickUpDetails } from '../types/Courier/UPS/UPSPickUpDetails'
import { UPSTimeInTransitResponse, ServiceSummary } from '../types/Courier/UPS/UPSTimeInTransitResponse'
import { IShippingAddress } from '../types/index'
// Scenarios: 
// 1. MISSED CUT OFF: true -> recall hook with tomorrow. { readyTime: now, closeTime: pickupLatest }
// 2. Date is ahead of currentDate (due to recursive fn), { readyTime: 9am, closeTime: pickupLatest } 
// 3. Date is today, current time before 9am (e.g. book at midnight) (Arbitary), { readyTime: 9am, closeTime: pickupLatest }
// 4. Date is today, current time later than 9am but before bookingCutOffTime, { readyTime: now (+15mins), closeTime: pickupLatest }

// DO WE NEED TO CONSIDER 2.5 HRS?

const getProductType = (data: UPSTimeInTransitResponse, shippingAddress: IShippingAddress): ServiceSummary => {
    const serviceSummary: ServiceSummary[] = Array.isArray(data.TimeInTransitResponse.TransitResponse.ServiceSummary) ? data.TimeInTransitResponse.TransitResponse.ServiceSummary : [data.TimeInTransitResponse.TransitResponse.ServiceSummary]

    const services = serviceSummary.filter(
        (product) => 
            product.Service.Description === 'UPS Ground' || 
            product.Service.Description === 'UPS Standard' ||
            product.Service.Description === 'UPS Worldwide Express Saver' || 
            product.Service.Description === 'UPS Express Saver'
    )

    return shippingAddress.country === 'US'
        ? services.filter((product) => product.Service.Description === 'UPS Ground')[0] // in US always use UPS Ground
        : (services.filter((product) => product.Service.Description === 'UPS Standard')[0] || services[0] ) // use UPS Standard if it exists, else take first option
}   

export const getPlannedPickupDateAndTime = (data: UPSTimeInTransitResponse, shippingAddress: IShippingAddress, currentDate: string, currentTime: string): IPickUpDetails => {
    const {
        EstimatedArrival: { CustomerCenterCutoff: bookingCutOffTime, Pickup: { Date: date, Time: pickupLatest },},
        Service: { Description: productCode }
    } = getProductType(data, shippingAddress)

    
    const arbitraryPickupEarliestTime = '0900' // seems a reasonable earliest time for a pick up!?

    //set earliest pickup time to 1500: https://jira.nap/browse/ORDS-387
    const pickupLatestTime = Number(pickupLatest) <= 130000 ? String(1500) : String(Number(pickupLatest) / 100) // e.g. 183000/100
    const missedCutOff: boolean = currentDate === date && currentTime > bookingCutOffTime 

    let plannedPickupDateAndTime;
    let isPickupEarliestNow = false;
    if (missedCutOff) {
        // SCENARIO 1
        plannedPickupDateAndTime = {
            CloseTime: pickupLatestTime,
            ReadyTime: currentTime,
            PickupDate: date
        }
    } else {
        // SCENARIO 2
        if (currentDate != date) {
            plannedPickupDateAndTime = {
                CloseTime: pickupLatestTime,
                ReadyTime: arbitraryPickupEarliestTime, 
                PickupDate: date
            }
        }
        // if currentDate IS equal to localCutoffDateAndTime
        else {
            // SCENARIO 3
            if (currentTime < arbitraryPickupEarliestTime) {
                const pickupEarliestTime = '0915' // add 15min grace, eg. availability request made 8:59 submitting request is done after 9am/arbitraryPickupEarliestTime
                plannedPickupDateAndTime = {
                    CloseTime: pickupLatestTime,
                    ReadyTime: pickupEarliestTime,  
                    PickupDate: date
                }
            } else {
                // SCENARIO 4
                isPickupEarliestNow = true
                plannedPickupDateAndTime = {
                    CloseTime: pickupLatestTime,
                    ReadyTime: currentTime, 
                    PickupDate: date
                }
            }
        }
    }

    return {
        missedCutOff,
        plannedPickupDateAndTime,
        isPickupEarliestNow,
        productCode
    }
}